//  local environment, qa1 - qa4 staging
export const DEVELOPMENT = "development";

//  prod
export const PRODUCTION = "production";

//  staging
export const STAGING = "staging";

export const app = {
  //  env is build env
  env: process.env.NODE_ENV,
  //  appEnv is the actual environment
  appEnv: process.env.APP_ENV || DEVELOPMENT,
};
